export default "__VITE_ASSET__d2f7969a__"